import { Grid, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { noticeToCreditorsFlow } from "../index";
import * as Yup from "yup";
import { Formik, FormikHelpers } from "formik";
import { OUTCOMES } from "../../../constants";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";

interface Values {
  state: string;
  county: string;
}

export const EstateAddressUnknownScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const currentScreen = noticeToCreditorsFlow.getCurrentFlowScreen(screenName);

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      state: "",
      county: "",
    },
    schema: Yup.object().shape({
      state: Yup.string().required(),
      county: Yup.string().required(),
    }),
  };

  const handleSubmit = async (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    setStatus("");
    try {
      if (!currentScreen) throw Error("couldn't determine currentScreen");

      // TODO: save to database

      noticeToCreditorsFlow.navigateToNext(
        currentScreen,
        OUTCOMES.complete,
        navigate
      );
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      // console.error(error);
      setSubmitting(false);
    }
  };

  return currentScreen ? (
    <FlowScreenWrapper title="Where did [Jacob] live?">
      <Formik
        initialValues={formikInit.values}
        validationSchema={formikInit.schema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          status,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={5}
              sx={{
                my: 1,
              }}
            >
              <Grid item xs={12}>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel>State</InputLabel>
                  <Select
                    name="state"
                    error={Boolean(touched.state && errors.state)}
                    label="State"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.state}
                  >
                    <MenuItem value="az">AZ</MenuItem>
                    <MenuItem value="ca">CA</MenuItem>
                    <MenuItem value="ny">NY</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel>County</InputLabel>
                  <Select
                    name="county"
                    error={Boolean(touched.county && errors.county)}
                    label="County"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.county}
                  >
                    <MenuItem value="maricopa">Maricopa</MenuItem>
                    <MenuItem value="king">King</MenuItem>
                    <MenuItem value="thurston">Thurston</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <ScreenFlowFormButtons
                  isSubmitting={isSubmitting}
                  status={status}
                  onBack={() => navigate(-1)}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
